import { Switch } from '@platform/ui-library';
import { FC } from 'react';
import { RootRoute } from '@app/const';
import { navigateToRoute } from '@app/utilities';
import { DesignerSetting } from '../../../DesignerSetting';
import { FormField } from '../../../form_components';
import { useServices } from '../../../hooks';

export type DesignRootFeatureFlagProps = {
  enabled: boolean;
  label: string;
  onEnable: () => Promise<void>;
  tooltip?: string;
};

export const DesignRootFeatureFlag: FC<DesignRootFeatureFlagProps> = ({
  enabled,
  label,
  onEnable,
  tooltip
}) => {
  const {
    errorMessageService,
    globalModalsService,
    loadingService
  } = useServices();

  return (
    <FormField label={label} tooltip={tooltip}>
      <Switch
        checked={enabled}
        className="ui-switch"
        onChange={async () => {
          if (DesignerSetting.s.is_public === 'true') {
            return errorMessageService.addError(
              'You cannot enable features from a public instance of D2.'
            );
          } else if (DesignerSetting.s.is_collab !== 'true') {
            return errorMessageService.addError(
              'You cannot enable features from a non-collaborative instance of D2.'
            );
          } else if (enabled) {
            return errorMessageService.addError(
              'You cannot disable features once enabled.'
            );
          }

          if (!await globalModalsService.openConfirmationModal({
            children: window.l.popup.enable_design_feature
          })) {
            return;
          }

          ++loadingService.loadingCount;
          await onEnable();
          window.apm.setSerializedChanged();
          --loadingService.loadingCount;
          if (await globalModalsService.openConfirmationModal({
            children: window.l.popup.enabled_design_feature
          })) {
            navigateToRoute(RootRoute.save);
          }
        }}
      />
    </FormField>
  );
};
